import { useTranslation } from "react-i18next";

const TrucksTableNoResultsContent: React.FC = () => {
  const { t } = useTranslation("production");
  return (
    <div className="text-center flex flex-col gap-1 py-4">
      <span className="text-sm text-theme-text">{t("trucksTable.noLoads")}</span>
      <div className="h-[2px] w-[15rem] bg-theme-table-border" />
    </div>
  );
};

export default TrucksTableNoResultsContent;